import * as React from 'react'
import type { SVGProps } from 'react'
import { Ref, forwardRef } from 'react'

interface SVGRProps {
  title?: string
  titleId?: string
}
const CircleButtonIcon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={42}
    viewBox="0 0 42 42"
    fill="none"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <circle cx={21} cy={21} r={14.5} stroke="white" />
    <circle className="loading" cx={21} cy={21} r={17.5} stroke="none" />
    <circle cx={21} cy={21} r={20.5} stroke="white" />
    <path
      d="M35.4238 6.42969L31.2021 10.6931M10.7968 31.2995L6.57502 35.5629"
      stroke="white"
    />
    <path d="M41.5 21L35.5 21M6.5 21L0.5 21" stroke="white" />
    <path
      d="M6.50391 6.50781L10.7465 10.7505M31.2526 31.2565L35.4953 35.4992"
      stroke="white"
    />
    <path d="M21 1V7M21 36V42" stroke="white" />
  </svg>
)
const ForwardRef = forwardRef(CircleButtonIcon)
export { ForwardRef as ReactComponent }
